// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"fcfdc0296e5bf86caef0","913":"8544551880d785e2e977"}[chunkId] + ".js";
};